<script context="module" lang="ts">import 'json-schema';
export function getDisplayName() {
    return "Media: Regular Vertical A";
}
export function getElementConfigSpec() {
    return {
        type: "object",
        properties: {
            padding: { type: "string", title: "Padding", description: "Padding around the card content." },
            backgroundColor: { type: "string", title: "Background Color", description: "Background color of the card." },
            imageUrl: { type: "string", format: "url", title: "Image URL", description: "URL for the main image." },
            categoryText: { type: "string", title: "Category Text", description: "Text for the category label." },
            categoryFontColor: { type: "string", title: "Category Font Color", description: "Font color for the category label." },
            categoryFontSize: { type: "string", title: "Category Font Size", description: "Font size for the category label." },
            categoryFontWeight: { type: "string", title: "Category Font Weight", description: "Font weight for the category label." },
            categoryUnderlineBorderColor: { type: "string", title: "Category Underline Border Color", description: "Border color for the underline of the category label." },
            categoryUnderlineBorderWidth: { type: "string", title: "Category Underline Border Width", description: "Border width for the underline of the category label." },
            categoryUnderlineBorderStyle: { type: "string", title: "Category Underline Border Style", description: "Border style for the underline of the category label." },
            categoryAreaBorderColor: { type: "string", title: "Category Area Border Color", description: "Border color for the area around the category label." },
            categoryAreaBorderWidth: { type: "string", title: "Category Area Border Width", description: "Border width for the area around the category label." },
            categoryAreaBorderStyle: { type: "string", title: "Category Area Border Style", description: "Border style for the area around the category label." },
            titleText: { type: "string", title: "Title Text", description: "Text for the article title." },
            titleFontColor: { type: "string", title: "Title Font Color", description: "Font color for the article title." },
            titleFontSize: { type: "string", title: "Title Font Size", description: "Font size for the article title." },
            titleFontWeight: { type: "string", title: "Title Font Weight", description: "Font weight for the article title." },
            descriptionText: { type: "string", title: "Description Text", description: "Text for the article description." },
            descriptionFontColor: { type: "string", title: "Description Font Color", description: "Font color for the article description." },
            descriptionFontSize: { type: "string", title: "Description Font Size", description: "Font size for the article description." },
            descriptionFontWeight: { type: "string", title: "Description Font Weight", description: "Font weight for the article description." },
            publishDateTime: { type: "string", format: "date-time", title: "Publish Date and Time", description: "Publish date and time for the article." },
            footerFontColor: { type: "string", title: "Footer Font Color", description: "Font color for the footer text." },
            footerFontSize: { type: "string", title: "Footer Font Size", description: "Font size for the footer text." },
            footerFontWeight: { type: "string", title: "Footer Font Weight", description: "Font weight for the footer text." }
        }
    };
}
export function getElementDataSourceSpec() {
    return {
        sources: [
            {
                type: 'SOURCE',
                title: 'Card Data',
                description: 'Arbitrary source of data for this card matching the configuration fields.',
                classes: '*'
            }
        ]
    };
}
</script>
  
  <script lang="ts">import "yinzcam-cards";
import CardBase from "components/cards/common/CardBase.svelte";
import { getFirstSourceStore, getTemplatedElementDataFromSource, buildInlineStyle, formatDateTimeRelative, addClassOnHoverAction } from "components/cards/utilities";
import "svelte/store";
import 'components/cards/common/CardsElementInterfaces';
export let element;
export let sources;
export let sourceStore;
$: {
    sourceStore = getFirstSourceStore($sources);
}
$: backgroundColor = getTemplatedElementDataFromSource(element, "backgroundColor", $sourceStore);
$: imageUrl = getTemplatedElementDataFromSource(element, "imageUrl", $sourceStore);
$: categoryAreaPadding = getTemplatedElementDataFromSource(element, "categoryAreaPadding", $sourceStore);
$: categoryText = getTemplatedElementDataFromSource(element, "categoryText", $sourceStore);
$: categoryPadding = getTemplatedElementDataFromSource(element, "categoryPadding", $sourceStore);
$: categoryFontColor = getTemplatedElementDataFromSource(element, "categoryFontColor", $sourceStore);
$: categoryFontSize = getTemplatedElementDataFromSource(element, "categoryFontSize", $sourceStore);
$: categoryFontWeight = getTemplatedElementDataFromSource(element, "categoryFontWeight", $sourceStore);
$: categoryBorderColor = getTemplatedElementDataFromSource(element, "categoryBorderColor", $sourceStore);
$: categoryBorderWidth = getTemplatedElementDataFromSource(element, "categoryBorderWidth", $sourceStore);
$: categoryBorderStyle = getTemplatedElementDataFromSource(element, "categoryBorderStyle", $sourceStore);
$: categoryAreaBorderColor = getTemplatedElementDataFromSource(element, "categoryAreaBorderColor", $sourceStore);
$: categoryAreaBorderWidth = getTemplatedElementDataFromSource(element, "categoryAreaBorderWidth", $sourceStore);
$: categoryAreaBorderStyle = getTemplatedElementDataFromSource(element, "categoryAreaBorderStyle", $sourceStore);
$: textAreaPadding = getTemplatedElementDataFromSource(element, "textAreaPadding", $sourceStore);
$: titleText = getTemplatedElementDataFromSource(element, "titleText", $sourceStore);
$: titleMaxLines = getTemplatedElementDataFromSource(element, "titleMaxLines", $sourceStore);
$: titleFontColor = getTemplatedElementDataFromSource(element, "titleFontColor", $sourceStore);
$: titleFontSize = getTemplatedElementDataFromSource(element, "titleFontSize", $sourceStore);
$: titleFontWeight = getTemplatedElementDataFromSource(element, "titleFontWeight", $sourceStore);
$: descriptionText = getTemplatedElementDataFromSource(element, "descriptionText", $sourceStore);
$: descriptionMaxLines = getTemplatedElementDataFromSource(element, "descriptionMaxLines", $sourceStore);
$: descriptionFontColor = getTemplatedElementDataFromSource(element, "descriptionFontColor", $sourceStore);
$: descriptionFontSize = getTemplatedElementDataFromSource(element, "descriptionFontSize", $sourceStore);
$: descriptionFontWeight = getTemplatedElementDataFromSource(element, "descriptionFontWeight", $sourceStore);
$: publishDateTime = getTemplatedElementDataFromSource(element, "publishDateTime", $sourceStore);
$: footerFontColor = getTemplatedElementDataFromSource(element, "footerFontColor", $sourceStore);
$: footerFontSize = getTemplatedElementDataFromSource(element, "footerFontSize", $sourceStore);
$: footerFontWeight = getTemplatedElementDataFromSource(element, "footerFontWeight", $sourceStore);
$: publishDateTimeDisplay = formatDateTimeRelative(publishDateTime);
$: style = buildInlineStyle("background-color", backgroundColor, "category-padding", categoryPadding, "category-font-color", categoryFontColor, "category-font-size", categoryFontSize, "category-font-weight", categoryFontWeight, "category-border-color", categoryBorderColor, "category-border-width", categoryBorderWidth, "category-border-style", categoryBorderStyle, "category-area-padding", categoryAreaPadding, "category-area-border-color", categoryAreaBorderColor, "category-area-border-width", categoryAreaBorderWidth, "category-area-border-style", categoryAreaBorderStyle, "text-area-padding", textAreaPadding, "title-max-lines", titleMaxLines, "title-font-color", titleFontColor, "title-font-size", titleFontSize, "title-font-weight", titleFontWeight, "description-max-lines", descriptionMaxLines, "description-font-color", descriptionFontColor, "description-font-size", descriptionFontSize, "description-font-weight", descriptionFontWeight, "footer-font-color", footerFontColor, "footer-font-size", footerFontSize, "footer-font-weight", footerFontWeight);
</script>
  
  <CardBase {element}>
    <div class="vertical-media" use:addClassOnHoverAction={'hovering'} style={style}>
      <div class="image-area">
        <img src={imageUrl} alt="" />
      </div>
      {#if categoryText}
      <div class="category-area">
        <div class="category-text">
          {categoryText}
        </div>
      </div>
      {/if}
      <div class="text-area">
        {#if titleText}
        <div class="title-text">
          {titleText}
        </div>
        {/if}
        {#if descriptionText}
        <div class="description-text">
          {descriptionText}
        </div>
        {/if}
        {#if publishDateTime}
        <div class="footer">
          <i class="f7-icons">clock</i>{publishDateTimeDisplay}
        </div>
        {/if}
      </div>
    </div>
  </CardBase>
  
  <style>
    *, *::before, *::after {
      box-sizing: border-box;
    }

    .vertical-media {
      display: flex;
      flex-direction: column;
      background-color: var(--background-color, unset);
      cursor: pointer;
      height: 100%;
    }

    .image-area {
      width: 100%;
      height: 100%;
      overflow: hidden;
      flex-grow: 1;
    }

    .image-area img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top center;
      transition: transform 1.0s ease;
    }

    .vertical-media.hovering .image-area img {
      transform: scale(1.2);
    }

    .category-area {
      width: 100%;
      padding: var(--category-area-padding, 0.0em 1.0em);
      border-bottom: var(--category-area-border-width, 1px) var(--category-area-border-style, solid) var(--category-area-border-color, transparent);
      flex-shrink: 1;
    }

    .category-text {
      width: -webkit-max-content;
      width: -moz-max-content;
      width: max-content;
      padding: var(--category-padding, 0.5em 0.0em);
      color: var(--category-font-color, unset);
      font-size: var(--category-font-size, 0.8em);
      font-weight: var(--category-font-weight, 600);
      border-bottom: var(--category-border-width, 3px) var(--category-border-style, solid) var(--category-border-color, transparent);
    }

    .text-area {
      padding: var(--text-area-padding, 0.5em 1.0em);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex-shrink: 1;
      gap: 1.0em;
    }

    .title-text {
      color: var(--title-font-color, unset);
      font-size: var(--title-font-size, 1.2em);
      font-weight: var(--title-font-weight, 800);
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: var(--title-max-lines, 2);
      line-clamp: var(--title-max-lines, 2);
      -webkit-box-orient: vertical;
    }

    .vertical-media.hovering .text-area .title-text {
      -webkit-text-decoration: underline;
      text-decoration: underline;
    }

    .description-text {
      color: var(--title-font-color, unset);
      font-size: var(--title-font-size, 0.9em);
      font-weight: var(--title-font-weight, unset);
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: var(--description-max-lines, 3);
      line-clamp: var(--description-max-lines, 3);
      -webkit-box-orient: vertical;
    }

    .footer {
      color: var(--footer-font-color, unset);
      font-size: var(--footer-font-size, 0.9em);
      font-weight: var(--footer-font-weight, unset);

      display: flex;
      align-items: center;
    }

    .f7-icons {
      font-size: 0.75em;
      font-weight: bold;
      margin-right: 0.4em;
    }</style>